import { CheckIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';

const LABEL = 'Done';

// Stands where a review button was once nothing is left to review; `detail` says how it closed.
export function DonePill({ detail }: { detail: string }) {
    return (
        <Tooltip content={detail}>
            <span className="inline-flex h-7 items-center gap-1 whitespace-nowrap rounded-md border border-teal-200 bg-teal-50 px-2 text-xs font-medium text-teal-700">
                <CheckIcon aria-hidden="true" className="h-3.5 w-3.5 flex-shrink-0" />
                {LABEL}
                <span className="sr-only">: {detail}</span>
            </span>
        </Tooltip>
    );
}
